import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";

interface Props {
  percentage: number;
}

const StyledProgressBar = styled.div`
  flex: 1;
  height: 4px;
  background-color: rgba(10, 119, 230, 0.07);
  border-radius: 6px;
`;

const StyledProgressBarFilled = styled(motion.div)`
  height: 4px;
  background-color: var(--primary-color);
  border-radius: 6px;
`;

function ProgressBar({ percentage }: Props) {
  return (
    <StyledProgressBar>
      <StyledProgressBarFilled
        initial={{ width: 0 }}
        animate={{ width: `${percentage}%` }}
        transition={{ type: "tween" }}
      />
    </StyledProgressBar>
  );
}

export default ProgressBar;
